import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ArticleListComponent } from './article-list/article-list.component';
import { HomeComponent } from './home/home.component';
import { ArticleComponent } from './article/article.component';
import { LegacyArticleRedirectComponent } from './legacy-article-redirect/legacy-article-redirect.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'tag',
    component: ArticleListComponent,
  },
  {
    path: 'category/:id/article/:name',
    component: ArticleComponent,
  },
  {
    path: 'tour/:id/article/:name',
    component: ArticleComponent,
  },
  {
    path: 'article/:name',
    component: LegacyArticleRedirectComponent,
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
